// ── Checkbox — галочка с подписью ────────────────────────────────────────────
// Нажимается вся строка (подпись тоже), высота строки 40 px — пальцем не промахнуться.
//   <Checkbox checked={on} onChange={(e) => setOn(e.target.checked)}>Делиться разборами</Checkbox>

import { SANS } from '../themes';
import { usePalette } from './theme';

export default function Checkbox({ checked, onChange, children, hint, disabled, style, C: Cp, ...rest }) {
  const C = usePalette(Cp);
  return (
    <label style={{ display: 'flex', alignItems: hint ? 'flex-start' : 'center', gap: 10, minHeight: 40, padding: hint ? '8px 0' : 0, boxSizing: 'border-box',
      fontFamily: SANS, fontSize: 14, color: C.text, cursor: disabled ? 'default' : 'pointer', opacity: disabled ? 0.5 : 1, ...style }}>
      <input type="checkbox" checked={checked} onChange={onChange} disabled={disabled}
        style={{ width: 18, height: 18, margin: hint ? '1px 0 0' : 0, flexShrink: 0, accentColor: C.blue, cursor: 'inherit' }} {...rest} />
      <span style={{ minWidth: 0, overflowWrap: 'break-word' }}>
        {children}
        {hint && <span style={{ display: 'block', fontSize: 12.5, color: C.faint, marginTop: 2, lineHeight: 1.4 }}>{hint}</span>}
      </span>
    </label>
  );
}
